module.exports = __webpack_public_path__ + "static/media/careNav@3x.9b987091.png";